/* eslint-disable */
import { Button, Chip, Grid } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import withWidth from '@material-ui/core/withWidth';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { compose } from 'recompose';
import withServices from '../../Contexts/Services/WithServices.context';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';
import Modal from '../Modal/Modal.component';
import grey from '@material-ui/core/colors/grey';

/**
 * ColumnsSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const ColumnsSelector = ({ applyColumns, cancelColumns, classes, open, originalColumns }) => {
  const [columns, setColumns] = useState(JSON.parse(JSON.stringify(originalColumns)));

  /**
   * Handles checkbox clicks
   * @param {string} name column name
   * @returns {void} void
   * @memberof ColumnsSelector
   */
  const handleChange = (name) => {
    const column = columns.find((el) => el.name === name);
    column.selected = !column.selected;
    setColumns(columns.slice());
    return;
  };

  /**
   * Resets selections
   * @returns {void} void
   * @memberof ColumnsSelector
   */
  const resetChanges = () => {
    cancelColumns();
    setColumns(JSON.parse(JSON.stringify(originalColumns)));
    return;
  };

  return (
    <Modal
      content={
        <FormControl component="fieldset">
          <FormGroup>
            <Grid container spacing={2}>
              {columns.map((column) => {
                return (
                  <Grid item>
                    <Chip variant={column.selected ? `default` : `outlined`} color={grey[100]} onClick={() => handleChange(column.name)} key={column.name} label={column.label} />
                  </Grid>
                );
              })}
            </Grid>
          </FormGroup>
        </FormControl>
      }
      footer={
        <Grid className={classes.textAlignRight} container justify="flex-end" spacing={2}>
          <Grid className={classes.flexGrow1} item>
            <Button className={classes.button} color="primary" onClick={resetChanges} variant="outlined">
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button className={classes.button} color="primary" onClick={() => applyColumns(columns)} variant="contained">
              Apply
            </Button>
          </Grid>
        </Grid>
      }
      onClose={resetChanges}
      open={open}
      paperClasses={classes.columnsSelector}
      title={
        <Grid container>
          <Grid item xs={12}>
            Select which columns to display
          </Grid>
        </Grid>
      }
    />
  );
};

ColumnsSelector.propTypes = {
  applyColumns: PropTypes.func.isRequired,
  originalColumns: PropTypes.array.isRequired,
  cancelColumns: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  classes: ThemeStatePropTypes.classes.isRequired,
};

export default compose(withWidth(), withServices)(ColumnsSelector);
